<template>
  <div class="account-admin container">
    <div class="row mb-2">
      <div class="col-12 col-md-9">
        <h1>
          Payroll
        </h1>
      </div>
      <div class="col-12 col-md-3 text-right">
        <button class="btn btn-primary" @click="onCreate">Add Adjustment</button>
      </div>

      <div class="col-12">
        <hr />
      </div>

      <div class="col-12">
        <div class="dashboard-card">
          <template v-if="loading">
            <Loader style="width: 100%" />
          </template>
          <template v-else-if="!exports">
            No results found.
          </template>
          <template v-else>
            <div class="row">
              <div class="col-12 col-md-3 offset-md-9">
                <form-component>
                  <div class="form-row">
                    <div class="col-12">
                      <input-datepicker id="pay_date" v-model="pay_date" name="pay_date" label="Pay Date" />
                    </div>
                  </div>
                </form-component>
              </div>
            </div>
            <table>
              <th>Export Date</th>
              <th>Description</th>
              <th>Download</th>
              <tr v-for="data in exports" :key="data.payoutExportId">
                <td>{{ data.when }}</td>
                <td v-if="data.description">{{ data.description }}</td>
                <td v-else>No Description</td>
                <td>
                  <button type="button" class="btn btn-primary" :disabled="!isValidExport || loading" @click="exportPayroll(data)">
                    <font-awesome-icon v-if="loading" :spin="true" :icon="['fas', 'spinner']" class="icon alt" />
                    <span v-else>Export</span>
                  </button>
                </td>
              </tr>
            </table>

            <Loader v-if="loading" style="width: 100%" />
            <button class='btn' v-else-if="nextPageToken" @click="load">
              Load Next
            </button>
          </template>
        </div>
      </div>
    </div>
    <vue-accessible-modal>
      <template v-slot:backdrop />
    </vue-accessible-modal>
  </div>
</template>

<script>
import FormComponent from '@/components/FormComponent.vue';
import InputDatepicker from '@/components/inputs/InputDatepicker.vue';
import InputSelect from "@/components/inputs/InputSelect.vue";
import InputText from '@/components/inputs/InputText.vue';
import Loader from '@/components/Loader';
import moment from 'moment'
import Payroll from './payroll'
import PayrollClient from '@/api/CounselorManagement/PayrollClient'
import AddPayrollAdjustmentModal from './AddPayrollAdjustmentModal.vue';

export default {
  name: 'Super-Admin-Payroll',
  components: {
    FormComponent,
    InputDatepicker,
    InputSelect,
    Loader,
    InputText
  },
  computed: {
    isValidExport() {
      return !!this.pay_date;
    }
  },
  data() {
    return {
      client: new PayrollClient(this.$http),

      exports: [],
      nextPageToken: null,
      pay_date: null,
      loading: false,
    };
  },
  async mounted() {
    await this.load();
  },
  methods: {
    async load() {
      try {
        this.loading = true;
        const response = await this.client.payoutExports(this.nextPageToken);
        this.nextPageToken = response.nextPageToken;

        for (const data of response.payouts) {
          this.exports.push({
            ...data,
            when: data.when ? moment(data.when).format("MM/DD/YYYY") : ''
          });
        }

      } catch (ex) {
        console.error(ex.toString());
      } finally {
        this.loading = false;
      }
    },
    async exportPayroll(exportData) {
      try {
        this.loading = true;

        const response = await this.client.payoutExport(exportData.id);

        const payDateString = moment(this.pay_date).format("MM/DD/YYYY");
        this.downloadExports(response.payouts, payDateString, exportData);

      } catch (ex) {
        console.error(ex.toString());
      }
    },
    async downloadExports(payouts, payDateString, exportData) {
      if (!this.isValidExport)
        return;

      const header = `"First Name","Last Name","Work Email","Pay Date","Amount","Notes"`;
      const files = {};

      for (const payout of payouts) {
        const line = this.payoutToCsvString(payout, payDateString);

        if (!files[payout.paidAs])
          files[payout.paidAs] = {
            body: "",
            title: Object.keys(Payroll.PaidAs).find(x => Payroll.PaidAs[x] == payout.paidAs) + 'Export-' + moment(exportData.when).format("DDMMMYYYY") + '_PayDate-' + moment(payDateString).format("DDMMMYYYY")
          };
        files[payout.paidAs].body += line;
      }

      const downloads = [];
      for (const key in files)
        downloads.push({
          title: files[key].title,
          data: header + files[key].body
        });

      for (const download of downloads)
        downloadFile(download.data, download.title + ".csv");

      this.loading = false;
    },
    payoutToCsvString(payout, payDate) {
      const note = this.generateNote(payout);
      return `\r\n"${payout.firstName}","${payout.lastName}","${payout.email}","${payDate}","${payout.amount}","${note}"`
    },
    generateNote(payout) {
      let note = `BetterMynd Payments: `;
      for (const eventName in payout.eventCounts) {
        const eventCount = payout.eventCounts[eventName];
        if (eventCount === 0)
          continue;

        note += eventCount;
        note += ' ';
        note += Payroll.GetEventDisplay(eventName, eventCount > 0);
        note += '. '
      }

      return note;
    },
    onCreate() {
      try {
      this.$modal.show(AddPayrollAdjustmentModal);
      } catch (error) {
        console.error(error);
      }
    }
  },
}

const downloadFile = (csv, title) => {
  var downloadLink = document.createElement("a");
  var blob = new Blob(["\ufeff", csv]);
  var url = URL.createObjectURL(blob);
  downloadLink.href = url;
  downloadLink.download = title;

  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
}
</script>

<style lang="scss" scoped>
th {
  padding: 5px;
}

td {
  padding: 5px;
  border-top: 1px solid $white
}

table {
  width: 100%;
}
</style>
